import React, { lazy } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { AuthenticationProvider } from "@authentication";

import "@styles";

const App = lazy(() => import("./App"));

const DefaultPolicy = lazy(() => import("@pages/PrivacyPolicy/PrivacyPolicy"));
const PrivacyPolicyByLang = lazy(
  () => import("@pages/PrivacyPolicy/PrivacyPolicyByLang"),
);
const DefaultTermsAndConditions = lazy(
  () => import("@pages/TermsAndConditions/TermsAndConditions"),
);
const TermsAndConditionsByLang = lazy(
  () => import("@pages/TermsAndConditions/TermsAndConditionsByLang"),
);

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <Routes>
        <Route path="/privacy-policy">
          <Route index element={<DefaultPolicy />} />
          <Route path=":lang" element={<PrivacyPolicyByLang />} />
          <Route path="*" element={<DefaultPolicy />} />
        </Route>
        <Route path="/terms-and-conditions">
          <Route index element={<DefaultTermsAndConditions />} />
          <Route path=":lang" element={<TermsAndConditionsByLang />} />
          <Route path="*" element={<DefaultTermsAndConditions />} />
        </Route>
        <Route
          path="*"
          element={
            <AuthenticationProvider>
              <App />
            </AuthenticationProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
